import axios from "axios"

export const getHeader = async () => {
    return axios.get('api/Header/Get')
}
